import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=c9d81f78&scoped=true&"
import script from "./ProductsView.vue?vue&type=script&lang=js&"
export * from "./ProductsView.vue?vue&type=script&lang=js&"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=c9d81f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d81f78",
  null
  
)

export default component.exports